import { render } from "./TheLegend.vue?vue&type=template&id=775db63e"
import script from "./TheLegend.vue?vue&type=script&lang=js"
export * from "./TheLegend.vue?vue&type=script&lang=js"

import "./TheLegend.vue?vue&type=style&index=0&id=775db63e&lang=css"

import exportComponent from "/mnt/d/Projects/santanu-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__